import type { InquiryItem } from '@/types/api';
import { ENABLE_CHECK_INQUIRY } from './TabSection';
import { useState, useEffect, useRef } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/atoms/PcTooltip';

const InquiryItemBody = ({ inquiry }: { inquiry: InquiryItem }) => {
  // const isCheckInquiry = ENABLE_CHECK_INQUIRY.includes(inquiry.MarketNameEnglish);

  const isUrgentInquiry = inquiry.QnaTypeCode === '긴급문의';

  if (isUrgentInquiry) {
    return (
      <div className="flex w-full flex-col text-[15px] font-medium leading-[22px] text-gr-800">
        긴급 문의 1건의 접수됐어요
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-[12px]">
      <div className="flex w-full flex-col gap-[4px]">
        <ProductName inquiry={inquiry} />
        <div className="w-full break-all text-gr-700 Body5M14">{inquiry.Content}</div>
      </div>
    </div>
  );
};

export default InquiryItemBody;

const ProductName = ({ inquiry }: { inquiry: InquiryItem }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // truncate 체크 함수
  const checkTruncate = () => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  };

  useEffect(() => {
    checkTruncate();
    window.addEventListener('resize', checkTruncate);
    return () => {
      window.removeEventListener('resize', checkTruncate);
    };
  }, [inquiry.ProductName]);

  return (
    <div className="w-full">
      <TooltipProvider>
        {isTruncated ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                ref={textRef}
                className="w-full truncate text-[15px] font-medium leading-[22px]  text-gr-800"
              >
                {inquiry.ProductName}
              </div>
            </TooltipTrigger>
            <TooltipContent>{inquiry.ProductName}</TooltipContent>
          </Tooltip>
        ) : (
          <div
            ref={textRef}
            className="w-full truncate text-[15px] font-medium leading-[22px] text-gr-800"
          >
            {inquiry.ProductName}
          </div>
        )}
      </TooltipProvider>
    </div>
  );
};
